import type { PriorityLevel } from './priority.js';

export const PRIORITY_PILL_BASE =
    'flex-shrink-0 inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold tracking-wide ring-1 ring-inset';

// High = soft amber; Extreme = the system's only solid pill.
export const PRIORITY_PILL_TONES: Record<'high' | 'extreme', string> = {
    high: 'bg-amber-50 text-amber-700 ring-amber-200',
    extreme: 'bg-red-600 text-white ring-red-600'
};

// The whole selector button wears the selected level's look instead of nesting a badge.
export const PRIORITY_BUTTON_TONES: Record<PriorityLevel, string> = {
    normal: 'border-gray-200 bg-white text-gray-600 hover:bg-gray-50',
    high: 'border-amber-200 bg-amber-50 text-amber-700 hover:bg-amber-100',
    extreme: 'border-red-600 bg-red-600 text-white hover:bg-red-700'
};

export const PRIORITY_CHEVRON_TONES: Record<PriorityLevel, string> = {
    normal: 'text-gray-400',
    high: 'text-amber-500',
    extreme: 'text-white/80'
};

export const PRIORITY_LABEL_TONES: Record<PriorityLevel, string> = {
    normal: 'text-gray-700',
    high: 'text-amber-700',
    extreme: 'text-red-700'
};
